import { useAuthStore } from '@/stores/auth';

/**
 * Feature flag gate. Resolution happened once at login — the token carries the tags this
 * session may see (`visibleFeatures`, an allow-list), every visible tag (New never expires)
 * (`newFeatures`), and the visible tags that are granted but not yet live (`previewFeatures`).
 * No client-side env or tenant bypass (the server opens everything outside prod): a missing
 * claim means every flagged feature is off.
 */
export const useFeatureFlags = () => {
    // '*' = every tag: non-prod servers open every flag and mark it NEW.
    const isEnabled = (tag) => {
        const visible = useAuthStore().visibleFeatures;
        return Array.isArray(visible) && (visible.includes('*') || visible.includes(tag));
    };

    const isNew = (tag) => {
        const newFeatures = useAuthStore().newFeatures;
        return isEnabled(tag) && (newFeatures.includes('*') || newFeatures.includes(tag));
    };

    /** Visible only because this account/user was granted — not released to everyone yet. */
    const isPreview = (tag) => isEnabled(tag) && useAuthStore().previewFeatures.includes(tag);

    return { isEnabled, isNew, isPreview };
};
